import { useNavigate } from 'react-router-dom'

interface BreadCrumb {
  site: string
  location: string
}

interface EditStateSettingsHeaderViewProps {
  stateName: string
  breadCrumbs: BreadCrumb[]
}

const EditStateSettingsHeaderView = ({ stateName, breadCrumbs }: EditStateSettingsHeaderViewProps) => {
  const navigate = useNavigate()

  return (
    /* ess-page-header: margin-bottom: 24px */
    <div className='mb-sp-3'>
      {/* ess-breadcrumb: flex, align-items center, gap 6px, margin-bottom 8px */}
      <nav className='mb-sp-1 flex items-center gap-sp-0.75'>
        {/* ess-breadcrumb-link: text-size-3, font-weight 400, line-height 20px, text-text-light (rgba(37,56,69,0.7) ≈ #253845B2 = text-text-light), hover → text-text-dark */}
        <button
          type='button'
          className='cursor-pointer border-0 bg-transparent p-0 text-size-3 font-normal leading-5 text-text-light hover:text-text-dark'
          onClick={() => navigate(breadCrumbs[0]?.location ?? '/management')}>
          Management
        </button>
        {/* ess-breadcrumb-sep: text-size-3, text-text-light */}
        <span className='text-size-3 text-text-light'>›</span>
        <button
          type='button'
          className='cursor-pointer border-0 bg-transparent p-0 text-size-3 font-normal leading-5 text-text-light hover:text-text-dark'
          onClick={() => navigate('/management?activeTab=States')}>
          States
        </button>
        <span className='text-size-3 text-text-light'>›</span>
        {/* ess-breadcrumb-current: text-size-3, font-weight 400, line-height 20px, text-text-dark */}
        <span className='text-size-3 font-normal leading-5 text-text-dark'>{stateName}</span>
      </nav>
      {/* ess-page-title: text-size-7 (32px), font-weight 600, line-height 40px, text-text-dark, margin 0 */}
      <h1 className='m-0 text-size-7 font-semibold leading-10 text-text-dark'>{stateName}</h1>
    </div>
  )
}

export default EditStateSettingsHeaderView
